import AddIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search'
import { Chip, Divider, InputAdornment, OutlinedInput, Stack, Typography } from '@mui/material'
import Fuse from 'fuse.js'
import React, { useEffect, useState } from 'react'
import InferenceList from '../Components/InferenceViewComponents/InferenceList'
import { NewInferenceModal } from '../Components/InferenceViewComponents/NewInferenceModal'
import CustomButton from '../Components/UiComponents/CustomButton'
import Loader from '../Components/UiComponents/Loader'
import { INFERENCE_STATUS_FILTER_LIST } from '../Configs/JobConstants'
import { InferenceTemplates } from '../NewComponents/Inference/InferenceTemplates'
import { useGetUserInferencesQuery } from '../Services/inferenceApi'
import { color } from '../Styles/Color'


export const Inference = () => {

  const [searched, setSearched] = useState("")
  const [filter, setFilter] = useState(["ACTIVE", "INACTIVE", "PROVISIONING"])
  const [searchedData, setSearchedData] = useState([])
  const [isNewInferenceModalOpen, setIsNewInferenceModalOpen] = useState(false)


  const { data: inferenceData, isLoading, isSuccess } =
    useGetUserInferencesQuery(null, {
      pollingInterval: 10000
    });

  useEffect(() => {
    if (isSuccess && inferenceData) {
      const options = {
        keys: ['name', 'id'],
        includeScore: true,
      }

      const fuse = new Fuse(inferenceData, options)

      if (searched.length > 0) {
        setSearchedData(
          fuse.search(searched)
            .filter(j => j.score < 0.5)
            .map(j => j.item)
        )
      } else {
        setSearchedData(inferenceData)
      }
    }
  }, [inferenceData, isSuccess, searched])


  if (
    isLoading
  ) {
    return <Stack height="70vh">
      <Loader />
    </Stack>
  }

  return (
    <Stack spacing={5}>
      <Stack spacing={2}>
        <Typography variant='h1' >Inference</Typography>
        <Stack direction="row" gap={1} alignItems="center">
          <Typography variant='body2' color={color.secondaryText}>
            Deploy open-source LLMs like Llama and Mistral on your own dedicated compute.
          </Typography>
          <Typography
            variant='body2'
            color={color.primary}
            sx={{
              "&:hover": {
                cursor: "pointer"
              }
            }}
            onClick={() =>
              window.open("https://docs.scalegen.ai/tutorials/deploy_llama3-1_8b_instruct", "_blank")
            }
          >
            Tutorials
          </Typography>
        </Stack>
      </Stack>
      <InferenceTemplates />
      <Stack spacing={1.8}>
        <Stack direction="row" justifyContent='space-between' alignItems="center" >
          <OutlinedInput
            value={searched}
            size='small'
            border={`1px solid ${color.borders}`}
            onChange={e => setSearched(e.target.value)}
            sx={{
              borderRadius: "8px",
              boxShadow: "0px 0px 4px 0px #00000029",
              width: "80%",
            }}
            placeholder='Search by name or id'
            startAdornment={<InputAdornment position="start">
              <SearchIcon fontSize='small' />
            </InputAdornment>}
          />
          <CustomButton onClick={() => setIsNewInferenceModalOpen(true)}>
            <AddIcon fontSize='small' sx={{ mr: 1 }} />
            New Inference
          </CustomButton>
        </Stack>
        <Stack direction="row" gap={2} alignItems="center">
          <Typography variant='h2'>Status</Typography>
          <Divider sx={{ borderColor: color.secondaryText }} orientation='vertical' variant='middle' flexItem />
          {
            INFERENCE_STATUS_FILTER_LIST.map((label, idx) => {
              return (
                <Chip
                  key={idx}
                  label={label}
                  clickable
                  sx={{
                    bgcolor: filter.includes(label.toUpperCase()) ? color.primary : color.white,
                    color: filter.includes(label.toUpperCase()) && color.white,
                    px: 0.5,
                    "&:hover": {
                      bgcolor: filter.includes(label.toUpperCase()) ? color.primary : color.white,
                    },
                  }}
                  onClick={() => {
                    const index = filter.indexOf(label.toUpperCase())
                    if (index === -1) {
                      setFilter(prev => [...prev, label.toUpperCase()])
                    } else {
                      setFilter(prev => prev.filter(item => item !== label.toUpperCase()))
                    }
                  }}
                />
              )
            })
          }
        </Stack>
      </Stack>
      <InferenceList
        data={searchedData}
        filter={filter}
      />
      <NewInferenceModal isOpen={isNewInferenceModalOpen} handleClose={() => setIsNewInferenceModalOpen(false)} />
    </Stack>
  )
}
